"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../static/icons/icons");

var _palette = require("../../../styles/palette");

var _Icon = _interopRequireDefault(require("../Icon"));

var _style = require("./style");

var Flight = function Flight(_ref) {
  var from = _ref.from,
      to = _ref.to,
      flight = _ref.flight;
  return _react["default"].createElement(_style.Container, null, _react["default"].createElement(_style.Title, null, from), _react["default"].createElement(_style.FlightStyled, null, _react["default"].createElement(_Icon["default"], {
    icon: _icons.ICONS.PLANEFULL,
    color: _palette.palette.bobBlack,
    size: 22
  }), flight), _react["default"].createElement(_style.Title, null, to));
};

Flight.propTypes = {
  from: _propTypes["default"].string,
  to: _propTypes["default"].string,
  flight: _propTypes["default"].string
};
Flight.defaultProps = {
  from: 'MAD',
  to: 'BCN',
  flight: null
};
var _default = Flight;
exports["default"] = _default;